@if (show()) {
<section #tooltipRef @fadeInOut role="tooltip" [attr.aria-hidden]="!show()"
    [ngStyle]="{ transform: 'translate(' + position().left + 'px, ' + position().top + 'px)'}"
    class="absolute pointer-events-none z-10 top-0 left-0 transition-transform duration-100 h-fit bg-background border-1 border-border-solid border-radius-6 dropshadow-sm py-[16px] px-[24px] w-fit flex gap-[7px] shadow-xl">

    @if (color()) {
    <div class="h-auto w-[4px] rounded-[20px]" [style.backgroundColor]="color()"></div>
    }
    <div class="flex flex-col gap-[8px]">
        @if (title()) {
        <h5 class="content-semibold text-card-foreground leading-[24px]">{{title() | translate }}</h5>
        }

        <div class="flex flex-col gap-[4px]">
            @for (item of content(); track $index) {
            <div class="flex gap-[60px] items-center">
                <div class="flex gap-[8px] items-center">
                @if (item.color) {
                <div class="w-[13px] h-[13px] rounded-[4px]" [style.backgroundColor]="item.color"></div>
                }

                @if (item.iconLeft) {
                <div class="w-[20px] h-[20px] flex items-center justify-center" aria-hidden="true">
                    <i
                        class="fi fi-rr-{{ item.iconLeft }} !leading-[16px] !text-[16px] !h-[16px] block text-muted-foreground"></i>
                </div>
                }

                @if (item.label) {
                <p class="content-regular text-muted-foreground leading-[24px]" [attr.aria-label]="item.label">{{item.label | translate }}</p>
                }
                </div>

                @if (item.value) {
                <span class="content-semibold text-card-foreground leading-[24px] ml-auto">{{item.value}}</span>
                }

                @if (item.iconRight) {
                <div class="w-[20px] h-[20px] flex items-center justify-center" aria-hidden="true">
                    <i
                        class="fi fi-rr-{{ item.iconRight }} !leading-[16px] !text-[16px] !h-[16px] block text-muted-foreground"></i>
                </div>
                }
            </div>
            }
        </div>
    </div>
</section>
}